module.exports = __webpack_public_path__ + "static/media/BM_WorkOrders.7cbcf18d.svg";